import styled from "@emotion/styled";
import { Badge } from "@mui/material";
import { ColorVariables } from "configs";
import { rem } from "utils";

export const StyledBadge = styled(Badge)({
  cursor: "pointer",
  width: rem(34),
  height: rem(34),
  borderRadius: "50%",
  "& .MuiBadge-badge": {
    backgroundColor: ColorVariables.KellyGreen,
    color: ColorVariables.KellyGreen,
    boxShadow: `0 0 0 2px ${ColorVariables.White}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
      boxSizing: "border-box",
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
});
